export class ViewApplicationDetailsBpamsConstants {
    static STEP_TITLE = "Details";
    static DESCRIPTION_LABEL = "Description";
    static IS_MINOR_BUILDING_WORK_LABEL = "Is there minor building work?";
    static SECTOR_LABEL = "Sector";
    static IS_RDP_LABEL = "Is it an RDP house?";
    static BUILDING_USE_LABEL = "Building use";
    static DESCRIPTION_FORM_CONTROL_NAME = "description";
    static IS_MINOR_BUILDING_WORK_FORM_CONTROL_NAME = "isMinorBuildingWork";
    static SECTOR_FORM_CONTROL_NAME = "sector";
    static IS_RDP_FORM_CONTROL_NAME = "isRDP";
    static BUILDING_USE_FORM_CONTROL_NAME = "buildingUse";
}
